import { render, staticRenderFns } from "./ReportBoxTrendUnits.vue?vue&type=template&id=434f199a&"
import script from "./ReportBoxTrendUnits.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTrendUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('434f199a')) {
      api.createRecord('434f199a', component.options)
    } else {
      api.reload('434f199a', component.options)
    }
    module.hot.accept("./ReportBoxTrendUnits.vue?vue&type=template&id=434f199a&", function () {
      api.rerender('434f199a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxTrendUnits.vue"
export default component.exports